import styled from 'styled-components';

const ContextModalContent = styled.div(() => `
  color: white;
  font-size: 12px;
`);

export {
  // eslint-disable-next-line import/prefer-default-export
  ContextModalContent
};
